import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FilterButton = ({ name, icon, onClick }) => {
    return (
        <button className="filter_button" onClick={onClick}>{![undefined, null, ""].includes(icon) && <FontAwesomeIcon icon={icon} />} {name}</button>
    )
}

export default FilterButton